import React, { memo } from 'react';
import { Form, Spin } from 'antd';
import { useHeaderImgActions, useHeaderImgState } from './Provider';
import { useHeaderImgData } from '../../../../hooks/useHeaderImgData';
import DspxCropper from '../../../../../../components/DspxCropper';

const getCropperProps = ({ isDeleted, state, defaultState }) => ({
  file: isDeleted ? null : state?.file || defaultState?.file,
  initialCroppedArea: isDeleted
    ? null
    : state?.initialCroppedArea || defaultState?.initialCroppedArea || null,
  croppedFile: isDeleted
    ? null
    : state?.croppedFile || defaultState?.croppedFile,
  zoom: isDeleted ? 1 : state?.zoom || defaultState?.zoom,
});

const HeaderImgField = ({ infoId }) => {
  const {
    data: defaultState,
    isFetching,
    limits,
    aspect,
    fileAccept,
    UploadCoverContent,
  } = useHeaderImgData(infoId);

  const { isDeleted, value: state } = useHeaderImgState();
  const { onCropOk, onDelete } = useHeaderImgActions();

  const cropperProps = getCropperProps({ isDeleted, state, defaultState });

  return (
    <Form.Item label="Обложка">
      <Spin spinning={Boolean(isFetching)}>
        <DspxCropper
          {...cropperProps}
          limits={limits}
          aspect={aspect}
          fileAccept={fileAccept}
          uploadContent={<UploadCoverContent />}
          onCropOk={onCropOk}
          onDelete={() => onDelete(Boolean(defaultState))}
          inForm
        />
      </Spin>
    </Form.Item>
  );
};

export default memo(HeaderImgField);
